import { createUseStyles } from 'react-jss'

import { mediumGrey } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  details: {
    padding: '0 8px',
    marginBottom: '10px'
  },
  title: {
    wordWrap: 'break-word',
    fontSize: 14,
    lineHeight: '17px',
    margin: 0,
    fontWeight: 400
  },
  subTitle: {
    wordWrap: 'break-word',
    fontSize: 10,
    lineHeight: '12px',
    color: mediumGrey,
    margin: '1px 0 0',
    fontWeight: 400
  }
})

export default useStyles
